export default function InputIsEmpty() {
    return {
        require: "ngModel",
        link: function (scope, elem, attrs, ctrl) {
            var v = elem.val().length == 0;

            ctrl.$inputIsEmpty = v;

            elem.on("keyup", function () {
                scope.$apply(function () {
                    v = elem.val().length == 0;

                    ctrl.$inputIsEmpty = v;
                });
            });
        },
    };
}
